import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "Inactive-Party-Report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./InactivePartyReport.html",
})
export class InactivePartyReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gradeCtrl: FormControl = new FormControl();
  gradeList = ["A", "B", "C", "D"];
  finyearCtrl: FormControl = new FormControl();
  finyearList: any[];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  exceldata: any;
  filter = {
    fin_id: 3,
    grade: "",
    season_from_id: 0,
    season_to_id: 0,
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "agent",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  seasonCtrlFrom: FormControl = new FormControl();
  seasonCtrlTo: FormControl = new FormControl();
  columns = [];
  toggleCol = [];

  filterExpand = false;

  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  printConfig: any = {
    title: "Inactive Party report",
    columns: [],
    rows: [],
  };

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      this.filter.fin_id = id;
      return fitem["finyear"];
    }
    return "";
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      let fin = res.data[0];
      // that.filterData.fin_id = fin['fin_id'];
      that.filter.fin_id = fin["fin_id"];
      that.finyearCtrl.setValue(fin["fin_id"]);
      //  that.getAgentSeasonalReport();
    });
  }

  ngOnInit(): void {
    this.loadSeasonList();

    this.LoadFinYearList();
    this.columns = [
      {
        name: "S.No",
        width: 50,
        minWidth: 50,
        maxWidth: 50,
        prop: "sno",
        // cellTemplate: this.snoTemplate,
        toggle: true,
        type: "sno",
      },
      {
        name: "Name",
        width: 300,
        minWidth: 300,
        maxWidth: 300,
        prop: "party_name",
      },
      {
        name: "Agent",
        width: 300,
        minWidth: 300,
        maxWidth: 300,
        prop: "agent_name",
      },
      {
        name: "Order",
        width: 100,
        cellClass: "txtRight",
        minWidth: 100,
        maxWidth: 100,
        prop: "order_qty",
        summary: "sum",
      },
      {
        name: "Sales",
        cellClass: "txtRight",
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        prop: "sale_qty",
        summary: "sum",
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentYearlyReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentYearlyReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentYearlyReport();
  }

  getAgentYearlyReport(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      grade: this.filter.grade,
      page: "1",
      fin_id: this.filter.fin_id,
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
    };
    let that = this;
    this.isLoadMask = this.reportService
      .getInactivePartyList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        //  that.dataList = res.data;
        that.page.count = res.data.length;
        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.exceldata = that.getData(that.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Inactive Party report",
          columns: that.columns,
          rows: that.gridOptions.data,
        };
        //  that.columns = res.columns;
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  clearFilter(): void {
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getAgentYearlyReport();
  }

  seasonFromFn(season: number) {
    let list: any[];
    let that = this;
    list = this.seasonList;
    let id = season && season["season_id"] ? season["season_id"] : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.filter.season_from_id = id;
      return fitem["season_name"];
    }
    return "";
  }

  seasonToFn(season: number) {
    let list: any[];
    let that = this;
    list = this.seasonList;
    let id = season && season["season_id"] ? season["season_id"] : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.filter.season_to_id = id;
      return fitem["season_name"];
    }
    return "";
  }

  loadSeasonList() {
    let that = this;
    that.reportService.getNewSeasonList(this.filter).then(function (res) {
      that.seasonList = res;
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/InactivePartyReport/InactivePartyReport.ts